export default __webpack_public_path__ + "static/media/photo--sm--misc-19.180fc702.jpg";